var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFullscreenIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Full-screen"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.7619 0L0.52381 0C0.209524 0 0 0.233333 0 0.583333L0 6.41667C0 6.76667 0.209524 7 0.52381 7C0.838095 7 1.04762 6.76667 1.04762 6.41667L1.04762 1.16667L5.7619 1.16667C6.07619 1.16667 6.28571 0.933333 6.28571 0.583333C6.28571 0.233333 6.07619 0 5.7619 0Z",
    transform: "matrix(1 0 0 1 3.637979E-12 0)",
    id: "Path",
    fill: "#FFFFFF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.7619 5.83333L1.04762 5.83333L1.04762 0.583333C1.04762 0.233333 0.838095 0 0.52381 0C0.209524 0 0 0.233333 0 0.583333L0 6.41667C0 6.76667 0.209524 7 0.52381 7L5.7619 7C6.07619 7 6.28571 6.76667 6.28571 6.41667C6.28571 6.06667 6.07619 5.83333 5.7619 5.83333Z",
    transform: "translate(3.637979E-12 15)",
    id: "Path",
    fill: "#FFFFFF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.7619 0C5.44762 0 5.23809 0.233333 5.23809 0.583333L5.23809 5.83333L0.52381 5.83333C0.209524 5.83333 0 6.06667 0 6.41667C0 6.76667 0.209524 7 0.52381 7L5.7619 7C6.07619 7 6.28571 6.76667 6.28571 6.41667L6.28571 0.583333C6.28571 0.233333 6.07619 0 5.7619 0Z",
    transform: "translate(15.714286 15)",
    id: "Path",
    fill: "#FFFFFF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.7619 0L0.52381 0C0.209524 0 0 0.233333 0 0.583333C0 0.933333 0.209524 1.16667 0.52381 1.16667L5.23809 1.16667L5.23809 6.41667C5.23809 6.76667 5.44762 7 5.7619 7C6.07619 7 6.28571 6.76667 6.28571 6.41667L6.28571 0.583333C6.28571 0.233333 6.07619 0 5.7619 0Z",
    transform: "translate(15.714286 0)",
    id: "Path",
    fill: "#FFFFFF",
    stroke: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreenIcon);
export default __webpack_public_path__ + "static/media/FullscreenIcon.7a9bdb4f.svg";
export { ForwardRef as ReactComponent };